import React, {Component} from "react";
import "./login.scss";
import {env, version} from "../../../config"
import {Link} from "react-router-dom";
import { withOktaAuth } from '@okta/okta-react';
import {AuthService} from "../../../services/auth-service";
import {Button, FormGroup, FormControl} from "react-bootstrap";
import "./login.scss";
import headerLogo from './../../../assets/new-logo.svg';
import {Helmet} from "react-helmet";
import {toast} from 'react-toastify';
import * as qs from 'query-string';
import { Divider } from 'semantic-ui-react';

async function checkUser() {
 
  var accessToken = await this.props.oktaAuth.getAccessToken()
 
  if ((await this.props.oktaAuth.isAuthenticated() === true) && !this.state.userInfo) {
    const userInfo = await this.props.oktaAuth.token.getUserInfo();
    if (this._isMounted) {

  
  this.authService
      .authenticateSSOUser(userInfo.email, accessToken, userInfo.family_name, userInfo.given_name)
      .then(  (res) =>
          {
             this.authService.cacheUserData(res)
             this.authService.updateSSOLogin(false)
                            
             this.setState(
                  {
                      authComplete : true
                  });

                  window.location.reload()

          })
      //.then(this.notifyParent)
      .catch((error) => {
          toast.error(error.message, {
              position: toast.POSITION.TOP_RIGHT,
              delay: 2000
          });
      });
    }
  }
}

class LoginSSO extends Component {
  _isMounted = false;
 
   
    constructor(props) {
        super(props);

        var companyOverride = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).company


        this.authService = new AuthService();
        this.login = this.login.bind(this);
        this.state = { userInfo: null,   company: companyOverride };
        this.handleSubmit = this.handleSubmit.bind(this);
     
        this.checkUser = checkUser.bind(this);
    }

    async login() {
        this.props.oktaAuth.signInWithRedirect();
      }

      async componentDidMount() {
        this._isMounted = true;
        this.checkUser();
      }
  
      async componentDidUpdate() {
        this._isMounted = true;
        //this.checkUser();
      }
  
      componentWillUnmount() {
        this._isMounted = false;
      }
      
      validateForm() {
        return true
      }
      handleSubmit = (event) => {
        if(this.state.company.toLowerCase() === "jll"||this.state.company.toLowerCase() === "jones lang lasalle")
{
        event.preventDefault();
        this.login();
}else
{
  event.preventDefault();

  toast.error("Unrecognised Company Name, to request access please contact your account manager or please try the Email login.", {
    position: toast.POSITION.TOP_RIGHT,
    delay: 1000
});

}
      }

      handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
    }



    render() {
        if( !this.props.authState ) {
            return (
              <div>Loading authentication...</div>
            );
          } else if( !this.props.authState.isAuthenticated ) {
            return (
              <div className="login">

              <Helmet>
                  <title>Inenco Portal | Log In</title>
              </Helmet>

              <img src={headerLogo} alt="header-logo" id="login-logo"/>

              <form onSubmit={this.handleSubmit}>
              

              <FormGroup controlId="company">
                        <FormControl
                            autoFocus
                            type="text"
                            value={this.state.company}
                            onChange={this.handleChange}
                            placeholder="Company Name"
                            className="username"
                        />
                    </FormGroup>
                  <Button
                      block
                      fluid
                      bsSize="large"
                      disabled={!this.validateForm()}
                      type="submit"
                      className="login-button">
                      Login
                  </Button>

                

              </form>
               
              <div className="reset-link-div">
                 
                  <Divider section> </Divider>
                  <Link to={{pathname: "/"
                          }} onClick={() => {
                              this.authService.updateSSOLogin(false)
                              window.location.reload()
                          }}  >Return to Login Page</Link>

              </div>
              <div className="version-details">
                  Version: {env} | {version}
              </div>
          </div>
            
              
            );
          } else if( this.props.oktaAuth.isAuthenticated() ) {
            return (
              <div>Completing authentication...</div>
            );
          }
    }
}

export default withOktaAuth(LoginSSO);
